import { useSupportedVersionWarning } from '../hooks/use-supported-version-warning.tsx';

const UnsupportedVersionCheck: React.FC = () => {
  useSupportedVersionWarning();

  return null;
};

export default UnsupportedVersionCheck;
